import React from 'react'
import PropTypes from 'prop-types'
import {useAccessToken} from '@salesforce/commerce-sdk-react'
import useCustomFetch from '../../hooks/useFetchContent'
import {Box, Skeleton} from '@salesforce/retail-react-app/app/components/shared/ui'

const ContentRenderer = ({
    contentIds,
    isSlot = true,
    validateEmptyHtml = false,
    placeholderSx,
    ...props
}) => {
    const {token} = useAccessToken()
    const {response, loading, error} = useCustomFetch(token, contentIds, isSlot)

    if (placeholderSx && loading && !error) return <Skeleton sx={placeholderSx} />

    if (!response || error) return

    if (validateEmptyHtml) {
        const sanitizedHtml = response.replace(/<!--[\s\S]*?-->/g, '')
        if (sanitizedHtml.trim() === '') return
    }

    return <Box {...props} dangerouslySetInnerHTML={{__html: response}}></Box>
}

export default ContentRenderer

ContentRenderer.propTypes = {
    contentIds: PropTypes.string.isRequired,
    isSlot: PropTypes.bool,
    validateEmptyHtml: PropTypes.bool,
    placeholderSx: PropTypes.object
}
